import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function ConsultaYReimpresionDeFc() {
  return (
    <ClipperPlaceholder title="Consulta y Reimpresión de FC" category="Operativas" />
  );
}
